import type {components, paths} from '../../openapi/auth.swagger';
import {axiosInstance} from '../axiosInstance';

export type PassportPhotos = components['schemas']['PassportPhotos'];

type UpdatePassportPhotosOperation = paths['/executor_web/identification/passport_photos']['patch'];

export type UpdatePassportPhotosResponse =
	UpdatePassportPhotosOperation['responses'][200]['content']['application/json'];

/** PATCH `/executor_web/identification/passport_photos` — multipart, см. swagger */
export function updatePassportPhotos(formData: FormData, signal?: AbortSignal) {
	return axiosInstance.patch<UpdatePassportPhotosResponse>('identification/passport_photos', formData, {signal});
}
